/**
 * Privacy reference code — a random identifier generated in the browser.
 *
 * The code is the only identifier passed to the game backend (as {USER_ID}
 * in the launch args), so players can reference it later to withdraw any
 * contributed voice data without us ever knowing who they are.
 */

const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
const CODE_LENGTH = 9;

export function generatePrivacyCode(): string {
  const bytes = new Uint8Array(CODE_LENGTH);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => ALPHABET[b % ALPHABET.length]).join("");
}
